import './image-uploader.less';
import {useMessages} from "../language/language";
import {
  classNames, hasText,
  MAX_FILE_SIZE,
  MAX_FILE_SIZE_TEXT, numberOr, SUPPORTED_IMAGES_ACCEPT,
  SUPPORTED_IMAGES_EXTENSION_LIST,
  SUPPORTED_IMAGES_REGEX
} from "utils/helpers";
import FlexContainer from "./flex-container";
import Loading from "./loading";
import {SyntheticEvent, useState } from 'react';

export function ImageUploader(props: {
  src: string
  alt: string
  maxSize?: { width: number, height: number }
  request(image: File): Promise<void>
})
{
  const msg = useMessages()
  const {src, alt, request} = props
  
  let maxWidth: number, maxHeight: number
  if (props.maxSize) {
    maxWidth = props.maxSize.width
    maxHeight = props.maxSize.height
  } else {
    maxWidth = 200
    maxHeight = 200
  }
  
  const [state, setState] = useState({
    isUploading: false,
    errorMessage: null as string|null
  })

  function setError(what: string|null) {
    setState(x => ({...x, errorMessage: what, isUploading: false}))
  }
  function setIsUploading(isUploading: boolean) {
    setState(x => ({...x, errorMessage: null, isUploading: isUploading}))
  }

  function handleUploadStart(e: SyntheticEvent<HTMLInputElement>) {
    const files = e.currentTarget.files
    if (!files || files.length == 0) {
      return setError(msg.errorFileNotSelected)
    }
    const file = files[0]
    if (file.size > MAX_FILE_SIZE) {
      return setError(msg.errorFileSizeTooBig(MAX_FILE_SIZE_TEXT))
    }
    if (!file.name.match(SUPPORTED_IMAGES_REGEX)) {
      return setError(msg.errorImageExtensionNotSupported(SUPPORTED_IMAGES_EXTENSION_LIST))
    }

    setIsUploading(true)
    request(file)
      .then(() => setIsUploading(false))
      .catch(() => setError(msg.serverError_generic))
  }

  return <FlexContainer 
    className={classNames('image-uploader', {
      'has-validation': hasText(state.errorMessage)
    })} 
    centerVertically 
    centerHorizontally
    vertical
  >
    <Loading 
      isLoading={state.isUploading}
      loadingMessage="..."
      style={{
        width: maxWidth,
        height: maxHeight,
      }}
    >
      <label
        className={classNames("image default-shadow-on-all-sides")}
        aria-roledescription={alt}
        style={{
          width: maxWidth,
          height: maxHeight,
          backgroundImage: `url(${src})`
        }}
      >
        <input
          type="file"
          onChange={handleUploadStart}
          accept={SUPPORTED_IMAGES_ACCEPT}
        />
      </label>
      
      {hasText(state.errorMessage) &&
        <div className="invalid-feedback">
          {state.errorMessage}
        </div>
      }
    </Loading>
  </FlexContainer>
}